import React, { useState } from 'react';
import { Button } from '@chakra-ui/button';
import { Heading, Text } from '@chakra-ui/layout';
import Layout from 'components/Layout';
import SEO from 'components/Seo';
import classes from './styles.module.scss';
import { useRouter } from 'next/router';
import { Sikka_FAQ } from 'data/faq';
import { Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { Icon } from '@chakra-ui/react';
import { BiSearch } from 'react-icons/bi';
import { faqSchema } from 'data/Schema/faqPageSchema';
import search from 'utils/search';
import { FaChevronLeft } from 'react-icons/fa';
import Link from 'next/link';
import useMediaQuery from 'hooks/useMediaQuery';
import FAQ from 'components/Faq';
// import InfiniteScroll from "react-infinite-scroll-component";
// import ToggleRow from 'components/ToggleRow';
// import SKCard from 'components/UI/SKCard';
// import { SIKKA_FAQS } from 'data/faq';
// import classes from './styles.module.scss';
// import queryString from 'query-string';
// import LinkIcon from 'public/assets/icons/link.svg';
// import { FAQS_PAGE } from '../../constants/route.const';
// import { useToast } from '@chakra-ui/toast';
// import { copyToClickBoard } from '../../utils';
// import { StorageService } from '../../service/Storage';
// import { useRouter } from 'next/router';
// const SUPPORTED_LANGS = ['en', 'hi'];

export default function FaqPage(props) {
  // const [lang, setLang] = useState('en'); //en||hi
  // const router = useRouter();
  // const toast = useToast();
  // const params = router.query;
  // const { isPro } = useSikkaPro();
  // const isProType = params.type === SIKKA_PRO_TYPE;

  // useEffect(() => {
  //   if (params.lang && SUPPORTED_LANGS.includes(params.lang)) {
  //     setLang(params.lang);
  //   }
  // }, []);

  // const FAQS =
  //   isPro || isProType ? [...SIKKA_PRO_FAQS, ...SIKKA_FAQS] : SIKKA_FAQS;

  const router = useRouter();

  const [showLength, setShowLength] = useState(6);
  const [faqData, setFaqData] = useState(Sikka_FAQ);

  const [value, setValue] = useState('');

  const handleChange = event => {
    let filterData = search(event.target.value);
    setFaqData(filterData || faqData);
    setValue(event.target.value);
  };

  const isTab = useMediaQuery('(max-width: 1000px)');

  const schemaCodes = [
    {
      type: 'application/ld+json',
      code: JSON.stringify(faqSchema)
    }
  ];

  return (
    <Layout>
      <SEO
        useTitleTemplate={false}
        url={router.pathname}
        title="Frequently Asked Questions About Money making App - Sikka"
        description="Get your questions answered about how to earn money with Sikka money making app and how to get real money in the UPI wallet or bank."
        // keywords={["Best Earning App", "Online Money Earning App"]}
        schemaCodes={schemaCodes}
        // image={"/assets/images/certified-orange.png"}
      />
      <section className={classes.headerSection}>
        {isTab && (
          <Link href={'/'}>
            <FaChevronLeft />
          </Link>
        )}
        <h1>Frequently Asked Questions</h1>
      </section>
      <section className={classes.searchBox}>
        <InputGroup>
          <Input
            value={value}
            onChange={handleChange}
            placeholder="Search something here..."
            size={'lg'}
          />
          <InputRightElement height="100%">
            <Icon as={BiSearch} boxSize={6} color="#FFC165" />
          </InputRightElement>
        </InputGroup>
      </section>
      <section className={classes.faqContainer}>
        <FAQ list={faqData} showLength={showLength} />
        {showLength === 6 && faqData.length > 6 && (
          <Button
            variant={'link'}
            className={classes.showBtn}
            onClick={() => setShowLength(Sikka_FAQ.length)}
          >
            Show More
          </Button>
        )}
      </section>
    </Layout>
  );
}
